export enum UfgTransportType {
  CHARTER_FLIGHT = 'CHARTER_FLIGHT',
  NON_CHARTER_FLIGHT = 'NON_CHARTER_FLIGHT',
  NON_AIR_TRANSPORT = 'NON_AIR_TRANSPORT',
  NO_TRANSPORT = 'NO_TRANSPORT',
}
